import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const SpecialTourListSkeleton = () => {
  return (
    <div className={s.box}>
      <div className={s.tags}>
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
      </div>

      <div className={s.container}>
        <Skeleton className={s.item} />
        <Skeleton className={s.item} />
        <Skeleton className={s.item} />
        <Skeleton className={s.item} />
        <Skeleton className={s.item} />
        <Skeleton className={s.item} />
      </div>
    </div>
  )
}
